import { render, staticRenderFns } from "./CBtn.vue?vue&type=template&id=2402fbdc"
import script from "./CBtn.vue?vue&type=script&lang=js"
export * from "./CBtn.vue?vue&type=script&lang=js"
import style0 from "./CBtn.vue?vue&type=style&index=0&id=2402fbdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports